module.exports = __webpack_public_path__ + "static/img/public.f915df8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/public.png
// module id = XAqQ
// module chunks = 127